import { AuthenticationLoadingLayout } from "#src/batteries-included-components/Layouts/Authentication/AuthenticationLoading";
import { Brandmark } from "#src/components/Presentational/Logos/Brandmark";
import { LoadingState } from "@validereinc/common-components";
import React from "react";

export const LoadingOnLoginLayout = () => {
  return (
    <AuthenticationLoadingLayout>
      <LoadingState
        label="Gathering your account and organization data..."
        size="large"
        indicator={<Brandmark isAnimated />}
      />
    </AuthenticationLoadingLayout>
  );
};
